<template>
  <ProviderLayout>
    <NuxtLoadingIndicator :height="2" />
    <div
      id="mainApp"
      class="main-app"
      :class="{
        'main-app--in-webview': isWebViewFarmi(useRequestHeader('user-agent')),
        'main-app--no-header': route?.meta?.showAppHeader === false || route?.meta?.hideHeaderMenu === true,
      }"
    >
      <NuxtLayout>
        <NuxtPage class="content-router" />
      </NuxtLayout>
    </div>
    <ClientOnly>
      <MicroFrontCoreModalView />
      <MicroFrontCoreDrawerView />
    </ClientOnly>
  </ProviderLayout>
</template>

<script setup lang="ts">
import {
  defineAsyncComponent,
  setPageLayout,
  useRequestHeader,
  useRoute,
  showError,
  useRouter,
  useHeadSafe,
  useNuxtApp,
  useAsyncData,
  useHead,
  useNuxtData,
  useRuntimeConfig,
} from '#imports'
import { getAppContext, microFrontListenerCore, setMicroFrontToolsConfig } from '@b2ag/micro-front-tools'
import { isWebViewFarmi } from '@b2ag/farmi-app-appro-tools'
import { useAnalyticService } from '@b2ag/plugin-aladin-gtm'
import type { Store } from '@b2ag/store'
import { useStore } from 'vuex'
import microFrontList from '@invivodf/micro-front-tools-config/micro-front-list.json'
import messagesEventBus from '@invivodf/micro-front-tools-config/messages-event-bus.json'
const MicroFrontCoreModalView = defineAsyncComponent(() => import('@b2ag/micro-front-core-modal/view'))
const MicroFrontCoreDrawerView = defineAsyncComponent(() => import('@b2ag/micro-front-core-drawer/view'))

const route = useRoute()
const store = useStore() as unknown as Store

// @ts-expect-error layout value is dynamic but always matches a valid layout key at runtime
setPageLayout(route.meta?.layout || getAppContext().appFrontType)

setMicroFrontToolsConfig({
  MICRO_FRONT_LIST: microFrontList,
  MESSAGES_EVENT_BUS: messagesEventBus,
})

microFrontListenerCore({
  iframe: { href: window?.location.origin },
  router: useRouter() as any,
  store,
  useAnalyticService,
  coreImports: {
    showError: showError as any,
    useAsyncData: useAsyncData as any,
    useHead,
    useHeadSafe,
    useRequestHeader: useRequestHeader as any,
    useNuxtApp,
    useNuxtData: useNuxtData as any,
  },
  callbackForMessages: () => {},
  uniqObject: 'default',
})

const { IS_SANDBOX } = useRuntimeConfig().public

const ProviderLayout = IS_SANDBOX
  ? defineAsyncComponent(() => import('./layouts/empty.vue'))
  : defineAsyncComponent(() => import('./providers/MainProvider.vue'))
</script>

<style lang="scss">
@import './assets/global';
</style>
